import {useProjectId} from "../ProjectName";
import {HardwareGroup} from "../../../../api/QuoteHardware";
import {useHwAPI} from "./HardwareGeneric";
import {useAlternative} from "../../quote/alternative/Alternative";
import {NativeAutoComplete} from "./NativeAutoComplete";

export function GroupNumberLookup(props: {
    onAssign(id: number): void;
    onCreate(name: string): void;
}) {
    const project = useProjectId();
    const api = useHwAPI();
    const alternative = useAlternative();

    return (
        <NativeAutoComplete<HardwareGroup>
            placeholder="Assign to group by entering group #"
            onSearch={async search => {
                const list = await api.list({
                    project,
                    alternative: alternative,
                    search
                })

                return list.data;
            }}
            makeLabel={v => v.name}
            onAssign={v => props.onAssign(v.id)}
            onCreate={v => props.onCreate(v)} />
    )
}